export class LogbookValidationKey {
  static readonly DAY = 'logbook/validation/day';
}
